import { render, staticRenderFns } from "./PackDealsList.vue?vue&type=template&id=588aae20&scoped=true&"
import script from "./PackDealsList.vue?vue&type=script&lang=js&"
export * from "./PackDealsList.vue?vue&type=script&lang=js&"
import style0 from "./PackDealsList.vue?vue&type=style&index=0&id=588aae20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588aae20",
  null
  
)

export default component.exports